/* eslint-disable babel/no-unused-expressions */
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import {
  Container,
  Button,
  Loading,
  TableLayout,
} from "../../theme/main.styled";
import RaiseLoader from "../../assets/raiser_loader.gif"
import { web3 } from "../../web3";
function PopBox(props) {
  const [open, setOpen] = useState(false);
  const [stakeAmountCalc, setStakeAmountCalc] = useState(0);
  const [amount, setAmount] = useState(0);
  const { farmingCalc, setFarmingCalc, farming, setFarming } = props;

  return (
    <>
      {open && (
        <PopUpMain>
          <PopupBx>
            <CloseBtn
              onClick={() => {
                setStakeAmountCalc(0);
                // setAmount(0);
                setFarmingCalc({
                  open: false,
                  // rate: stakeCalc.rate,
                  // calRate: stakeCalc.calRate,
                });
              }}
            >
              <i className="far fa-times-circle"></i>
            </CloseBtn>
            {/* <StakeMsg className="completed">
              <i className="fas fa-check-circle"></i>
              <h4>Stake Completed!</h4>
              <p>
                You have staked 1 RST to the selected pool Check your
                transaction <a href="">here</a>
              </p>
              <Button className="primary full">DONE</Button>
            </StakeMsg> */}
            {/* <StakeMsg className="failed">
                        <i className="fas fa-check-circle"></i>
                        <h4>Stake Failed!</h4>
                        <p>Something happened</p>
                        <Button className='primary full'>Close</Button>
                    </StakeMsg> */}

            {/* <Loading></Loading>
                    <StakeCalc>
                        <h4>Farm</h4>
                        <p>Amount in Cake-LP</p>
                        <div className='inputblock'>
                            <TextBox type='text' placeholder='Enter Amount'></TextBox>
                            <span>Max</span>
                        </div>
                        <Button className='primary full'>CONFIRM</Button>
                    </StakeCalc> */}
          </PopupBx>
        </PopUpMain>
      )}
      {farming.open && (
        <PopUpMain>
          <PopupBx>
            <CloseBtn
              onClick={() => {
                // setStakeAmountCalc(0);
                // farmingCalc.setFarmAmountVal();
                setFarming({
                  open: false,
                });
              }}
            >
              <i className="far fa-times-circle"></i>
            </CloseBtn>
            {farming.txnStatus.status === "process" ? (
              <StakeMsg className="completed">
                <Loading />
                <img src={RaiseLoader} alt="raiserLoader" width={80} height={80} style={{marginBottom:"38px"}}/>
                <h4>Please wait transaction is in process....</h4>
              </StakeMsg>
            ) : farming?.txnCompleteModal ? (
              <StakeMsg className="completed">
                <i className="fas fa-check-circle"></i>
                <h4>
                  {farming.currentFunction === "stake" ? "Farming" : "Withdraw"}{" "}
                  Completed!
                </h4>
                <p>
                  Your LP tokens has been farmed. Check your transaction{" "}
                  <a
                    href={`https://testnet.bscscan.com/tx/${farming.txnHash}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    here
                  </a>
                </p>
                <Button
                  className="primary full"
                  onClick={() => {
                    setFarming({
                      open: false,
                    });
                  }}
                >
                  DONE
                </Button>
              </StakeMsg>
            ) : farming?.stakeFailedModal ? (
              <StakeMsg className="failed">
                <i className="fas fa-check-circle"></i>
                <h4>Stake Failed!</h4>
                <p>Something happened</p>
                <Button
                  className="primary full"
                  onClick={() => {
                    setFarming({
                      open: false,
                    });
                  }}
                >
                  Close
                </Button>
              </StakeMsg>
            ) : (
              <StakeCalc>
                <h4>
                  {farming.currentFunction === "stake" ? "Stake" : "Withdraw"}
                </h4>
                <p>Amount in {farming.token}</p>
                <div className="inputblock">
                  <TextBox
                    type="text"
                    placeholder="Enter Amount"
                    value={farming.amount.value}
                    onChange={(e) => {
                      if (!isNaN(e.target.value)) {
                        farming.setAmount({ index: 0, value: e.target.value });
                      }
                    }}
                  ></TextBox>
                  {/* <span> */}
                  <button
                    onClick={(e) => {
                      farming.setAmount({
                        index: 0,
                        value:
                          farming.currentFunction === "stake"
                            ? farming.userPoolDetails?.userBalance
                            : web3.utils.fromWei(
                                farming.userPoolDetails
                                  ? farming.userPoolDetails.userDeposits[0]
                                  : "0"
                              ),
                      });
                      setFarming({
                        ...farming,
                        amount: {
                          index: 0,
                          value:
                            farming.currentFunction === "stake"
                              ? farming.userPoolDetails?.userBalance
                              : web3.utils.fromWei(
                                  farming.userPoolDetails
                                    ? farming.userPoolDetails.userDeposits[0]
                                    : "0"
                                ),
                        },
                      });
                    }}
                  >
                    Max
                  </button>
                  {/* </span> */}
                </div>
                <Button
                  className="primary full"
                  onClick={async () => {
                    farming.currentFunction === "stake"
                      ? farming.makeTransaction("stake", 0)
                      : farming.withdraw(0);
                    // farming.makeTransaction("stake");
                  }}
                >
                  {farming.amount?.value > farming.userPoolDetails?.allowance
                    ? "Approve"
                    : "Confirm"}
                </Button>
              </StakeCalc>
            )}
          </PopupBx>
        </PopUpMain>
      )}
      {farmingCalc.open && (
        <PopUpMain>
          <PopupBx>
            <CloseBtn
              onClick={() => {
                setStakeAmountCalc(0);
                // farmingCalc.setFarmAmountVal();
                setFarmingCalc({
                  open: false,
                });
              }}
            >
              <i className="far fa-times-circle"></i>
            </CloseBtn>
            <StakeCalc>
              <h4>Farm Calculation</h4>
              <TextBox
                type="text"
                value={stakeAmountCalc ? stakeAmountCalc : ""}
                onChange={(e) => {
                  farmingCalc.setFarmAmountVal(e.target.value);
                  setStakeAmountCalc(e.target.value);
                }}
                placeholder="Enter Amount"
              ></TextBox>
              <TableLayout className="popList">
                <label>
                  1D <span>{farmingCalc?.testamt[1]}</span>
                </label>
                <label>
                  7D <span>{farmingCalc?.testamt[7]}</span>
                </label>
                <label>
                  30D <span>{farmingCalc?.testamt[30]}</span>
                </label>
                <label>
                  APY <span>{farmingCalc.APY} %</span>
                </label>
                <p>
                  Calculated based on current rates. Rates are estimates
                  provided for your convenience only, and by no means represent
                  guaranteed returns.
                </p>
              </TableLayout>
            </StakeCalc>
          </PopupBx>
        </PopUpMain>
      )}
    </>
  );
}

const StakeMsg = styled.div`
  text-align: center;
  padding-top: 15px;
  i {
    font-size: 8.2rem;
    margin-bottom: 30px;
  }
  h4 {
    font-size: 2.5rem;
    margin-bottom: 18px;
  }
  p {
    font-size: 1.7rem;
    margin: 0 0 38px;
    line-height: 1.6;
    a {
      color: var(--primary);
    }
  }
  &.completed {
    i {
      color: var(--green);
      text-align: center;
      box-shadow: inset 0 0 0 2px var(--green), 0 0 60px var(--green);
      width: 8.2rem;
      height: 8.2rem;
      border-radius: 100%;
    }
  }
  &.failed {
    i {
      color: var(--red);
      text-align: center;
      box-shadow: inset 0 0 0 2px var(--red), 0 0 60px var(--red);
      width: 8.2rem;
      height: 8.2rem;
      border-radius: 100%;
    }
  }
`;

const StakeCalc = styled.div`
  padding-top: 12px;
  h4 {
    font-size: 2.5rem;
    font-weight: 600;
    margin-bottom: 40px;
  }
  .popList {
    margin-top: 30px;
    label:last-child {
      border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    }
  }
  .inputblock {
    position: relative;
    margin: 15px 0 20px;
    button {
      width: 60px;
      height: 30px;
      line-height: 30px;
      background: var(--text-color);
      border-radius: 4px;
      color: var(--primary);
      text-align: center;
      position: absolute;
      top: 50%;
      right: 12px;
      margin-top: -15px;
      font-size: 1.5rem;
    }
  }
`;
const TextBox = styled.input`
  border-radius: 5px;
  border: 1px solid var(--text-color);
  background: none;
  width: 100%;
  height: 52px;
  font-size: 15px;
  color: var(--text-color);
  padding: 10px 15px;
`;
const PopupBx = styled.div`
  width: 442px; /* height: 370px; */
  background: rgb(255, 255, 255, 0.12);
  border: 2px solid rgb(255, 255, 255, 0.2);
  border-radius: 25px;
  backdrop-filter: blur(8px) brightness(1.2);
  position: relative;
  padding: 25px;
  max-width: calc(100% - 40px);
`;
const CloseBtn = styled.div`
  color: var(--text-color);
  position: absolute;
  right: 15px;
  top: 15px;
  font-size: 2rem;
  cursor: pointer;
`;
const PopUpMain = styled.div`
  background: rgb(0, 0, 0, 0.7);
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 10000;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default PopBox;
